import { getEnvConfig } from '@hbs-us/contracts';

import { getAppEnv } from '../../lib/env.js';

/**
 * Credentialed api-host file URLs for job-scoped stored files (blueprints +
 * expense receipts). Mirrors `features/invoices/exportLinks.ts`: the api host is
 * read from `@hbs-us/contracts` `getEnvConfig().domains.api` — NEVER hardcoded
 * (threat T-22-31-01 / the RESEARCH anti-pattern).
 *
 * These are the endpoints delivered by plan 22-21. A view action must fetch them
 * THROUGH `lib/download.ts` (openCredentialed) so apiFetch attaches the in-memory
 * bearer + `X-Tenant-Subdomain`; a plain `<a href>` / navigation to the api host
 * carries neither and 401s.
 */

function apiBaseUrl(): string {
  return `https://${getEnvConfig(getAppEnv()).domains.api}`;
}

/** Credentialed blueprint file GET (api-host, 22-21). */
export function blueprintFileUrl(jobId: number, blueprintId: number): string {
  return `${apiBaseUrl()}/api/v1/jobs/${jobId}/blueprints/${blueprintId}/file`;
}

/** Credentialed expense-receipt GET (api-host, 22-21). Exported for the expense
 *  row list when it lands — the rows are not rendered on the job detail tab yet. */
export function expenseReceiptUrl(expenseId: number): string {
  return `${apiBaseUrl()}/api/v1/expenses/${expenseId}/receipt`;
}
